import React, { Component } from "react";
import Loader from "./preloader";

class PlaceholderIMG extends Component {
	state = {
		src: null,
		_isMounted: false,
		loading: true
	};
	mainImg = null;
	img = null;
	componentDidMount() {
		this.setState({ _isMounted: true });
		this.initialImgCheck();
	}
	componentDidUpdate(prevProps) {
		const { src } = this.props;
		if (prevProps.src !== src) {
			this.initialImgCheck();
		}
	}
	componentWillUnmount() {
		this.setState({ _isMounted: false });
		if (this.img) {
			this.img.removeEventListener("load", () => null);
			this.img.removeEventListener("error", () => null);
			this.img = null;
		}
		if (this.mainImg) {
			this.mainImg.removeEventListener("load", () => null);
			this.mainImg = null;
		}
	}
	initialImgCheck = () => {
		const { src } = this.props;
		if (src) {
			this.setState({ loading: true });
			this.img = document.createElement("img");
			this.img.src = src;
			this.img.addEventListener("load", () => {
				this.setState({ src, loading: false });
			});
			this.img.addEventListener("error", () => {
				this.renderImg();
			});
		} else {
			this.renderImg();
		}
	};
	renderImg = () => {
		const { width = 40, height = 40, bg, color = "#000", text } = this.props;
		const t = text ? text : "NO IMAGE";
		const canvas = document.createElement("canvas");
		canvas.width = width;
		canvas.height = height;
		const ctx = canvas.getContext("2d");
		if (bg) {
			ctx.fillStyle = bg;
			ctx.fillRect(0, 0, width, height);
		}
		const fontSize = Math.min(20, Math.max(width / 15, 7));
		ctx.font = `${fontSize}px Arial`;
		ctx.fillStyle = color;
		ctx.textAlign = "center";
		ctx.textBaseline = "middle";
		ctx.fillText(t, width / 2, height / 2);
		const src = canvas.toDataURL();
		this.setState({ src, loading: false });
	};
	render() {
		const { src, _isMounted, loading } = this.state;
		if (_isMounted) {
			const {
				id = null,
				alt = "Provide alt!",
				className = null,
				width = null,
				height = null,
				onLoad,
				objectFit = "none"
			} = this.props;
			return src ? (
				<React.Fragment>
					{loading && <Loader />}
					<img
						ref={(event) => (this.mainImg = event)}
						src={src}
						alt={alt}
						className={className}
						id={id}
						width={width}
						height={height}
						onLoad={(event) => {
							return onLoad ? onLoad(event) : null;
						}}
						style={{ objectFit }}
					/>
				</React.Fragment>
			) : null;
		}
		return null;
	}
}

export default PlaceholderIMG;
